import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { createColumn } from "@/lib/table/columnFactory";
import type { Ticket } from "../types/ticket.types";
import { TicketReferenceCell } from "./cells/TicketCells";

export const referenceColumn = createColumn<Ticket>({
  id: "reference",
  header: ({ column }) => <DataTableColumnHeader column={column} title="Réf" />,
  cell: ({ row }) => <TicketReferenceCell ticket={row.original} />,
  size: 80,
});
